/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const TruncatedText = (props) => (
  <div className="cmp-truncatedtext" style={{ width: `calc(100% - ${props.widthOffset})` }}>
    {props.children}
  </div>
);
TruncatedText.propTypes = {
  widthOffset: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default TruncatedText;
